<template>
  <div class="table-search font-h3">
    <div class="search-left">
      <div class="search-left__add" v-if="!addButton && limitShow"></div>
      <div class="search-left__add" v-if="!limitShow"></div>
      <div
        class="search-left__add"
        @click="handleAddTableItem"
        v-if="addButton && limitShow"
      >
        <img src="../../assets/images/normal_add.svg" alt="添加建筑" />
        <span>{{ $route.meta.addText }}</span>
      </div>
      <div class="search-left__delete" v-if="limitShow">
        <img
          :src="
            deleteList[0] ? deletePic.normal_delete : deletePic.disabled_delete
          "
          alt="删除"
          @click="handleDeleteTableItem"
        />
      </div>
      <div class="search-left__delete" v-if="!limitShow"></div>
    </div>
    <slot></slot>
    <div class="search-right">
      <div class="search-right__input">
        <el-input
          :placeholder="$route.meta.searchPlaceholder"
          v-model="searchKeyWords"
          @change="handleSearchTableItem"
        ></el-input>
        <img
          @click="handleSearchTableItem"
          src="../../assets/images/normal_search.svg"
          alt="搜索"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import { roleJudge } from '../../config/roleJudge';
export default {
  name: 'TableHeaderSearch',
  props: {
    deleteList: {
      type: Array,
      default: () => []
    },
    addButton: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters('login', ['limitShow'])
  },
  data() {
    return {
      searchKeyWords: '',
      deletePic: {
        normal_delete: require('../../assets/images/normal_delete.svg'),
        disabled_delete: require('../../assets/images/disabled_delete.svg')
      },
      showAdd: true,
      showDelete: true
    };
  },
  methods: {
    /**
     * 删除表格项回调
     */
    handleDeleteTableItem() {
      this.$emit('onShowDelete', this.showDelete);
    },
    /**
     * 添加表格项回调
     */
    handleAddTableItem() {
      this.$emit('onShowAdd', this.showAdd);
    },
    /**
     * 搜索表格项回调
     */
    handleSearchTableItem() {
      this.$emit('onSearchTableItem', this.searchKeyWords);
    }
  }
};
</script>

<style lang="scss">
.table-search {
  display: flex;
  justify-content: space-between;
  padding-top: 29px;
  width: 1024px;
  background-color: #fff;
  .search-left {
    margin-left: 20px;
    &__add {
      height: 48px;
      cursor: pointer;
      span {
        line-height: 48px;
        color: $color-primary;
        padding-left: 10px;
      }
    }
    &__delete {
      width: 20px;
      height: 20px;
      img {
        cursor: pointer;
      }
    }
  }
  .search-right {
    &__input {
      position: relative;
      .el-input {
        width: 360px;
        height: 38px;
      }
      .el-input__inner:focus {
        outline: none;
        border-color: $color-border-light;
      }
      img {
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
      }
    }
  }
}
</style>
